export default function HealthWarningBanner() {
  return (
    <div
      role="region"
      aria-label="Advertencia sanitaria obligatoria"
      className="relative z-10 bg-ink-950 border-t border-ink-700 text-bone-200 text-[12px] sm:text-[13px]"
    >
      <div className="container-app py-2 flex items-center justify-center gap-3 text-center">
        <p>
          <strong className="text-bone-50">Advertencia sanitaria:</strong>{' '}
          La nicotina contenida en este producto es una sustancia adictiva. Venta exclusiva a mayores de 18 años.
        </p>
      </div>
    </div>
  );
}
